module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "services"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row main-content"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "services-text-main-container"
  }, [_c('div', {
    staticClass: "small-title pull-left"
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.title)
    }
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "services-main-container",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.state.subTitle))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.pTextTop)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "services-icon-text-container"
  }, [_c('div', {
    staticClass: "left-icon-text"
  }, [_c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-left-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_logistica_int.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4"
  }, [_vm._v(_vm._s(_vm.state.serviceText1))])]), _vm._v(" "), _c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-left-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_fronterizo.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4"
  }, [_vm._v(_vm._s(_vm.state.serviceText2))])]), _vm._v(" "), _c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-left-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_operador.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4",
    domProps: {
      "innerHTML": _vm._s(_vm.state.serviceText3)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-left-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_urgentes.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4"
  }, [_vm._v(_vm._s(_vm.state.serviceText4))])])]), _vm._v(" "), _c('div', {
    staticClass: "right-icon-text"
  }, [_c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-right-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_transporte.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4"
  }, [_vm._v(_vm._s(_vm.state.serviceText5))])]), _vm._v(" "), _c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-right-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_entrega.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4",
    domProps: {
      "innerHTML": _vm._s(_vm.state.serviceText6)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-right-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_direccion.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4"
  }, [_vm._v(_vm._s(_vm.state.serviceText7))])]), _vm._v(" "), _c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-right-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_almacen.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4"
  }, [_vm._v(_vm._s(_vm.state.serviceText8))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 pull-right blue-container-cert",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    },
    attrs: {
      "data-aos": "fade-in"
    }
  }, [_c('div', {
    staticClass: "small-title-bluediv pull-right"
  }, [_c('hr'), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contenedor-cert"
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "100px",
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.state.certTitle))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./../../assets/logos/logo_certificacion_canacar.png")
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./../../assets/logos/logo_certificacion_oea.png")
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./../../assets/logos/logo_certificacion_ctpat.png")
    }
  })])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 footer-container",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/contacto",
      "tag": "a"
    }
  }, [_c('h3', [_vm._v("CONTÁCTANOS")])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border-top": "1px solid white"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Copy right @2017 - All Rights Reserved")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 pull-left",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('img', {
    staticClass: "white-truck",
    attrs: {
      "src": require("./../../assets/imgs/servicios_foto1.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99f9c85e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/servicios/ServiciosmainPage.vue
// module id = 152
// module chunks = 0